import { render, staticRenderFns } from "./adjust-refund.vue?vue&type=template&id=2a254a58&scoped=true&"
import script from "./adjust-refund.vue?vue&type=script&lang=js&"
export * from "./adjust-refund.vue?vue&type=script&lang=js&"
import style0 from "./adjust-refund.vue?vue&type=style&index=0&id=2a254a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a254a58",
  null
  
)

export default component.exports